export default {
    topics: [
        {
            title: ' Subscribe ',
            href: 'sm-newsgroup-Subscribe.html',
            attributes: { 'data-id': 'sm-newsgroup-Subscribe' },
            menu: { hasChildren: false },
            tocID: 'sm-newsgroup-Subscribe-d66e3221',
            topics: [],
        },
        {
            title: ' Unsubscribe ',
            href: 'sm-newsgroup-Unsubscribe.html',
            attributes: { 'data-id': 'sm-newsgroup-Unsubscribe' },
            menu: { hasChildren: false },
            tocID: 'sm-newsgroup-Unsubscribe-d66e3229',
            topics: [],
        },
    ],
};

